export default __webpack_public_path__ + "static/media/Frame.10db41dd.svg";